import { render } from "./checkboxList.vue?vue&type=template&id=1a35fb82&scoped=true"
import script from "./checkboxList.vue?vue&type=script&lang=js"
export * from "./checkboxList.vue?vue&type=script&lang=js"

import "./checkboxList.vue?vue&type=style&index=0&id=1a35fb82&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a35fb82"]])

export default __exports__